// API Configuration
// Uses environment variable if set, otherwise falls back to same origin (for production deployments)
export const API_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
